
import { Vue, Options } from "vue-class-component";
import CardDashboardClient from "@/app/ui/views/dashboard/component/client/component/card-dashboard-client.vue";
import DetailStatusCardDashboardClient from "@/app/ui/views/dashboard/component/client/component/detail-status-card-dashboard-client.vue";
import { IS_SENDER_ACCOUNT } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import ProgressBar from "@/app/ui/components/progress-bar/index.vue";
import DonutChart from "@/app/ui/components/donut-chart/index.vue";
import { DashboardController } from "@/app/ui/controllers/DashboardController";
import checkRolePermission from "@/app/infrastructures/misc/common-library/CheckRolePermission";
import { CLAIM } from "@/app/infrastructures/misc/RolePermission";
import formatPrice from '@/app/infrastructures/misc/common-library/v2/FormatPrice';

@Options({
  components: {
    DetailStatusCardDashboardClient,
    CardDashboardClient,
    ProgressBar,
    DonutChart
  }
})
export default class ClaimDetailCard extends Vue {
  mounted() {
    this.fetchClaimDataCorporateDashboard();
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize)
  }
  async fetchClaimDataCorporateDashboard() {
    this.isLoading = true;
    const response = await DashboardController.getCorporateDashboardDeliveryData(
      {
        path: "/claim/total",
        sttCategory: "",
        cache: true
      }
    );
    this.claimPerStatusData[0].value = response.totalClaimSubmitted;
    this.claimPerStatusData[1].value = response.totalClaimApproved;
    this.claimPerStatusData[2].value = response.totalClaimRejected;
    this.claimPerStatusData[3].value = response.totalClaimCompleted;
    this.claimMbg = response.totalClaimMbg;
    this.totalClaim = response.totalClaim;
    this.isLoading = false;
  }

  isLoading = true;
  totalClaim = 0;
  claimPerStatusData: Array<{
    titleKey: string;
    type: string;
    value: number;
    loading: boolean;
    color: string;
    ableToClick: boolean;
  }> = [
    {
      titleKey: "dashboard.claimSubmitted",
      type: "on_request",
      value: 0,
      loading: false,
      color: "#FFCB01",
      ableToClick: false
    },
    {
      titleKey: "dashboard.claimApproved",
      type: "on_approved",
      value: 0,
      loading: false,
      color: "#7ACB90",
      ableToClick: false
    },
    {
      titleKey: "dashboard.claimRejected",
      type: "on_rejected",
      value: 0,
      loading: false,
      color: "#F05C72",
      ableToClick: false
    },
    {
      titleKey: "dashboard.claimCompleted",
      type: "on_done",
      value: 0,
      loading: false,
      color: "#8E78DB",
      ableToClick: false
    }
  ];
  get claimPerStatus() {
    return this.claimPerStatusData.map((item) => ({
      ...item,
      title: this.$t(item.titleKey),
      ableToClick: this.ableToViewDetail
    }));
  }

  // claim mbg
  claimMbg = 0;
  get accountCurrency() {
    return AccountController.accountData?.accountCurrency ?? "IDR";
  }
  get accountCurrencySymbol() {
    return (
      AccountController.accountData?.accountCurrencySymbol ??
      this.accountCurrency
    );
  }
  get formattedClaimMbg() {
    return formatPrice(
      this.claimMbg,
      "",
      this.accountCurrency as "IDR" | "MYR",
      this.accountCurrencySymbol
    );
  }
  get chartData() {
    return this.claimPerStatus.map((item: any) => {
      return item.value;
    });
  }
  get chartColor() {
    return this.claimPerStatus.map((item: any) => {
      return item.color;
    });
  }
  valueProgressBar(val: number, maxValue: number) {
    return (val / maxValue) * 100;
  }

  get ableToViewDetail() {
    if (IS_SENDER_ACCOUNT) return true;
    return checkRolePermission(CLAIM.ENABLE);
  }
  onClickDetail(dashboardInfo: string) {
    if (!this.ableToViewDetail) return;
    DashboardController.openNewPageFromDashboardCorporate(dashboardInfo);
  }

  chartHeight = "150"
  checkScreenSize() {
    if (window.innerWidth >= 599) {
      this.chartHeight = "150";
    } else {
      this.chartHeight = "250";
    }
  }
}
